import { render, staticRenderFns } from "./TemplatePdfDocumentComponent.vue?vue&type=template&id=af9de68a&scoped=true&"
import script from "./TemplatePdfDocumentComponent.vue?vue&type=script&lang=js&"
export * from "./TemplatePdfDocumentComponent.vue?vue&type=script&lang=js&"
import style0 from "./TemplatePdfDocumentComponent.vue?vue&type=style&index=0&id=af9de68a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af9de68a",
  null
  
)

export default component.exports